module.exports = __webpack_public_path__ + "img/ent.842606ae.svg";